export * from './baProfilePicture';
export * from './baAppPicture';
export * from './baKameleonPicture';



// WEBPACK FOOTER //
// /Desenvolvimento/PMP/painel/src/app/theme/pipes/index.ts